<div
  class="basic-info-container"
  [class.compact]="compact">
  <div class="basic-info-content">
    <!-- Patient Name - Highlighted Section -->
    <div class="info-field info-field--name">
      <label class="field-label field-label--name">PATIENT NAME</label>
      <div class="field-value field-value--name">
        <div class="name-accent-bar"></div>
        <span class="patient-name-text">{{ patientName }}</span>
      </div>
    </div>

    <!-- Patient ID -->
    <div class="info-field">
      <label class="field-label">PATIENT ID</label>
      <div class="field-value">
        {{ patientId || 'Not specified' }}
      </div>
    </div>

    <!-- Date of Birth -->
    <div class="info-field">
      <label class="field-label">DATE OF BIRTH</label>
      <div class="field-value">
        {{ dateOfBirth || 'Not specified' }}
      </div>
    </div>

    <!-- Gender -->
    <div class="info-field">
      <label class="field-label">GENDER</label>
      <div class="field-value">
        {{ gender || 'Not specified' }}
      </div>
    </div>
  </div>

  <!-- Edit Patient Button — only shown when patient already exists in the system -->
  <button *ngIf="existsInSystem" mat-icon-button
          class="edit-patient-button"
          (click)="editPatient.emit()"
          matTooltip="Edit Patient"
          matTooltipPosition="below"
          aria-label="Edit Patient">
    <mat-icon>edit</mat-icon>
  </button>

  <!-- Create Patient Button — only shown when patient is not in the system -->
  <button *ngIf="!existsInSystem" mat-icon-button
          class="create-patient-button"
          (click)="createPatient.emit()"
          matTooltip="Patient not in system — Create Patient"
          matTooltipPosition="below"
          aria-label="Create Patient">
    <mat-icon>person_add</mat-icon>
  </button>

  <!-- Change Patient Button - Top Right -->
  <button mat-icon-button
          class="change-patient-button"
          (click)="changePatient.emit()"
          matTooltip="Change Patient"
          matTooltipPosition="below"
          aria-label="Change Patient">
    <mat-icon>compare_arrows</mat-icon>
  </button>
</div>
